import { makeStyles } from '@material-ui/core/styles'

export const crStyles = makeStyles((theme) => ({
  accordionHeaderContainer: {
    background: theme.palette.backgroundColor.ternary,
    borderRadius: theme.spacing(0.5),
  },
  footer: {
    width: '100%',
    position: 'absolute',
    bottom: 0,
    background: theme.palette.backgroundColor.secondary,
    borderTop: `1px solid ${theme.palette.backgroundColor.main}`,
    borderRadius: theme.spacing(0, 0, 1, 1),
  },
  footerIcon: {
    color: theme.palette.components.icon,
    cursor: 'pointer',
    padding: '2px',
    '&:hover': {
      backgroundColor: theme.palette.button.hoverLight,
      borderRadius: '5px',
    },
  },
  iconFooter: {
    height: '40px',
  },
  iconImage: {
    height: 20,
    width: 100,
    [theme.breakpoints.down(400)]: {
      width: 80,
    },
  },
  // about us tab
  aboutUsTextContainer: {
    padding: theme.spacing(1, 2),
    [theme.breakpoints.down(400)]: {
      width: 300,
    },
  },
  aboutUsHeaderContainer: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    paddingLeft: theme.spacing(0.5),
    height: '30px',
    color: theme.palette.primary.main,
    '&:hover': {
      background: theme.palette.button.hoverDark,
    },
    '&:focus': {
      background: theme.palette.button.hoverDark,
    },
  },
  aboutUsNavText: { paddingLeft: theme.spacing(0.5) },
  aboutUsHeaderBackArrow: {
    cursor: 'pointer',
  },
  aboutUsImageDiv: {
    height: 156,
    width: 300,
    overflow: 'hidden',
    textAlign: 'center',
    alignContent: 'center',
    backgroundColor: theme.color.rcsaBlue,
  },
  // contact card
  contactContainer: {
    overflowY: 'auto',
    padding: theme.spacing(1),
    height: 443,
    maxHeight: 443,
    width: 335,
    [theme.breakpoints.down(769)]: {
      height: 'calc(100dvh - 316px)',
    },
    [theme.breakpoints.down(400)]: {
      width: 300,
    },
  },
  contactCard: {
    width: '100%',
    '&:last-child': {
      marginTop: theme.spacing(2),
    },
  },
  contactCardContent: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    paddingTop: theme.spacing(0.5),
    '&:last-child': {
      paddingBottom: '0px',
    },
  },
  contactIconTextContainer: {
    display: 'flex',
    alignItems: 'center',
    color: theme.palette.components.icon,
    cursor: 'pointer',
    '&:hover': {
      background: theme.palette.button.hoverDark,
      borderRadius: theme.spacing(0.5),
      padding: theme.spacing(0, 1),
    },
    '&:focus': {
      background: theme.palette.button.hoverDark,
      borderRadius: theme.spacing(0.5),
      padding: theme.spacing(0, 1),
    },
  },
  contactText: {
    '&::before': {
      whiteSpace: 'pre',
    },
    marginLeft: theme.spacing(0.5),
    color: theme.palette.components.linkText,
  },
  divider: {
    width: 300,
  },
  // events tab
  eventsTextContainer: {
    padding: theme.spacing(1, 2),
    [theme.breakpoints.down(400)]: {
      width: 300,
    },
  },
  eventsHeaderContainer: {
    textAlign: 'center',
    padding: theme.spacing(1),
  },
  eventsCalendarButtonContainer: {
    width: '50%',
  },
  eventsImageDiv: {
    width: 300,
    height: 225,
    margin: 'auto',
    backgroundColor: theme.palette.components.rcsaBlue,
    [theme.breakpoints.down(400)]: {
      width: 268,
      height: 200,
    },
  },
  // checklist tab
  checklistContainer: {
    overflowY: 'auto',
    padding: theme.spacing(1),
    height: 443,
    maxHeight: 443,
    width: 335,
    [theme.breakpoints.down(769)]: {
      height: 'calc(100dvh - 316px)',
    },
    [theme.breakpoints.down(400)]: {
      width: 300,
    },
  },
  checklistGridItem: {
    width: '100%',
  },
  accordion: {
    width: '100%',
  },
  accordionItem: {
    display: 'flex',
    alignItems: 'center',
    borderBottom: `1px solid ${theme.palette.base.lightGray}`,
    '&:first-child': {
      borderTop: `1px solid ${theme.palette.base.lightGray}`,
    },
  },
  accordionItemText: {
    paddingTop: theme.spacing(0.5),
    marginLeft: theme.spacing(0.5),
  },
  accordionDetails: {
    background: theme.palette.backgroundColor.ternary,
    borderRadius: theme.spacing(0.5),
    marginTop: theme.spacing(-1),
  },
  itemBullet: {
    color: theme.palette.components.rcsaBlue,
    display: 'flex',
  },
  downArrow: {
    color: theme.palette.components.rcsaBlue,
  },
  // amenities tab
  amenitiesListContainer: {
    padding: theme.spacing(0.5),
    height: 318,
    maxHeight: 318,
    overflowY: 'auto',
    overflowX: 'hidden',
    [theme.breakpoints.down(769)]: {
      height: 'calc(100dvh - 351px)',
    },
  },
  amenitiesItemContainer: {
    padding: '0px',
    '&:last-child': {
      paddingBottom: theme.spacing(1),
    },
  },
  amenitiesTextContainer: {
    padding: `0px ${theme.spacing(0.5)}px`,
  },
  amenitiesImageDiv: {
    minHeight: 120,
    maxHeight: 180,
    overflow: 'hidden',
    alignContent: 'center',
  },
}))

export default crStyles
